import { Component, computed, inject } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { ProgressService } from '../../lib/progress.service';

@Component({
  selector: 'app-booking-persons',
  imports: [RouterLink],
  templateUrl: './booking-persons.component.html',
  styleUrl: './booking-persons.component.css',
})
export class BookingPersonsComponent {
  public progressService = inject(ProgressService);
  public router = inject(Router);
  public personCountOptions = computed<number[]>(() => {
    if(!this.progressService.selectedLodge()?.table_factors) {
      return [];
    }

    let factor = 1;
    const personOptions = [];

    do {
      const options = this.progressService.selectedLodge()?.table_factors.map((base) => base * factor);
      factor++;
      if(options !== undefined && options?.length > 0) {
        personOptions.push(...options);
      }
    } while (Math.max(...personOptions) < 200 && factor < 40)

    return Array.from(new Set(personOptions.flat())).sort((n1,n2) => n1 - n2);

  });

  setPersonCount(event: Event) {
    this.progressService.personsSelected(+(event.target as HTMLInputElement).value)
  }
}
